window.addEventListener('DOMContentLoaded', (event) => {
  const header = document.querySelector('header')
  if (header) {
    const ul = header.querySelector('.mv')
    const children = Array.from(ul.children)
    if (children.length > 1) {
      const slide = KeenSlider(
          ul,
          {
            loop: true,
            slides: {
              perView: 1,
              spacing: 24
            },
            selector: children
          },
          [
            (slider) => {
              let timeout
              let mouseOver = false
              function clearNextTimeout() {
                clearTimeout(timeout)
              }
              function nextTimeout() {
                clearTimeout(timeout)
                if (mouseOver) return
                timeout = setTimeout(() => {
                  slider.next()
                }, 3000)
              }
              slider.on("created", () => {
                slider.container.addEventListener("mouseover", () => {
                  mouseOver = true
                  clearNextTimeout()
                })
                slider.container.addEventListener("mouseout", () => {
                  mouseOver = false
                  nextTimeout()
                })
                nextTimeout()
              })
              slider.on("dragStarted", clearNextTimeout)
              slider.on("animationEnded", nextTimeout)
              slider.on("updated", nextTimeout)
            }
          ]
      )
      const arrows = header.querySelectorAll('.arrow')
      arrows.forEach((arrow) => {
        const isNext = arrow.classList.contains('next')
        arrow.addEventListener('click', isNext ? slide.next : slide.prev)
      })

      const dots = header.querySelector('.dots')
      const dotsChildren = []
      let i = 0
      for (;;) {
        const slideOrder = i
        if (i + 1 > slide.track.details.slides.length) break
        const child = document.createElement('li')
        child.addEventListener('click', () => {
          slide.moveToIdx(slideOrder)
        })
        child.classList = slideOrder === 0 ? ['active'] : []
        dotsChildren.push(child)
        i++
      }
      dots.replaceChildren(...dotsChildren)
      slide.on('slideChanged', (instance) => {
        const current = instance.track.absToRel(instance.track.details.abs)
        Array.from(dots.children).forEach((child, index) => {
          child.classList = index === current ? ['active'] : []
        })
      })
    }
  }
})
